import React from 'react'
import { Scale32 } from '@carbon/icons-react'

export default ({}) => (
    <div style={{position: 'absolute', left: 0, top: 0, zIndex: 100000, opacity: 0.90, pointerEvents: 'none', width: '100%', height: '100%', background: '#141414', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column'}}>
        <Scale32 style={{color: 'white'}} />
        <p style={{marginTop: '0.5rem', color: 'white', fontSize: 12, opacity: 0.65}}>Edit mode</p>
    </div>
)